module.exports = __webpack_public_path__ + "img/13.9a28d009.png";